import { useEffect, useState, useRef, useCallback } from 'react'; // Added useCallback
import successful from '../../../assets/images/successful.png';
import attention from '../../../assets/images/attention.png';
import faceMatch from '../../../assets/images/faceMatch.png';
import panImage from '../../../assets/images/panVerification.png';
import faceLive from '../../../assets/images/facelive.png';
import openMap from '../../../assets/images/openMap.png';
import ckyckImage from '../../../assets/images/ckyckImage.png';
import digilocker from '../../../assets/images/digilocker.png';
import documentImage from '../../../assets/images/documentSample.png';
import viewBig from '../../../assets/images/viewBig.png';
import frame from '../../../assets/images/Frame.png';
import bankImg from '../../../assets/images/bankImg.png';
import ViewFile from '../Files/viewFile.js';
import axiosInstance from '../../../helpers/axios.js';
import { useSelector, useDispatch } from 'react-redux';
import './index.css';

// Face Match Confirmation Modal Component
const FaceMatchConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        maxWidth: '480px',
        width: '100%',
        transform: 'scale(1)',
        transition: 'all 0.3s ease'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px',
          borderBottom: '1px solid #f1f5f9'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M20 6L9 17l-5-5"/>
              </svg>
            </div>
            <div>
              <h2 style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#1f2937', 
                margin: 0 
              }}>
                Face Match Confirmation
              </h2>
              <p style={{ 
                fontSize: '14px', 
                color: '#6b7280',
                margin: '4px 0 0 0'
              }}>
                Confirm to proceed with face matching
              </p>
            </div>
          </div>
          <button
            onClick={onCancel}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          {/* Information Message */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            gap: '12px', 
            marginBottom: '24px',
            padding: '16px',
            backgroundColor: '#f0fdf4',
            borderRadius: '12px',
            border: '1px solid #bbf7d0'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              backgroundColor: '#dcfce7',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              marginTop: '2px'
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v6m0 6v6"/>
                <path d="M21 12h-6m-6 0H3"/>
              </svg>
            </div>
            <div>
              <p style={{ 
                color: '#15803d', 
                fontWeight: '600', 
                marginBottom: '8px', 
                fontSize: '16px' 
              }}>
                Face Match Process
              </p>
              <p style={{ 
                color: '#15803d', 
                fontSize: '14px', 
                lineHeight: '1.5',
                margin: 0 
              }}>
                Face match verification will be initiated to compare your selfie with CKYC records.
              </p>
            </div>
          </div>
          {/* Actions */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={onConfirm}
              style={{
                flex: 1,
                backgroundColor: '#16a34a',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '12px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#15803d'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#16a34a'}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 6L9 17l-5-5"/>
              </svg>
              <span>Proceed</span>
            </button>
            <button
              onClick={onCancel}
              style={{
                padding: '12px 24px',
                border: '2px solid #e5e7eb',
                backgroundColor: 'white',
                color: '#374151',
                borderRadius: '12px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '16px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.borderColor = '#d1d5db';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.borderColor = '#e5e7eb';
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Initiate CKYC Confirmation Modal Component
const InitiateCkycConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)',
      display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '16px'
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', maxWidth: '480px', width: '100%'
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '24px', borderBottom: '1px solid #f1f5f9'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px', height: '40px', borderRadius: '12px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'linear-gradient(135deg, #D32028 0%, #a01820 100%)'
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
              </svg>
            </div>
            <div>
              <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                Initiate CKYC
              </h2>
              <p style={{ fontSize: '14px', color: '#6b7280', margin: '4px 0 0 0' }}>
                Confirm to proceed with CKYC initiation
              </p>
            </div>
          </div>
          <button onClick={onCancel} style={{
            width: '32px', height: '32px', borderRadius: '50%', border: 'none',
            backgroundColor: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div style={{ padding: '24px' }}>
          <div style={{
            display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '24px',
            padding: '16px', backgroundColor: '#fff5f5', borderRadius: '12px', border: '1px solid #fecaca'
          }}>
            <div style={{
              width: '32px', height: '32px', backgroundColor: '#fee2e2', borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D32028" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <div>
              <p style={{ color: '#D32028', fontWeight: '600', marginBottom: '8px', fontSize: '16px' }}>
                CKYC Request
              </p>
              <p style={{ color: '#b91c1c', fontSize: '14px', lineHeight: '1.5', margin: 0 }}>
                This will initiate a CKYC request for the applicant using their PAN number. Click Proceed to confirm.
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button onClick={onConfirm} style={{
              flex: 1, backgroundColor: '#D32028', color: 'white', padding: '12px 16px',
              borderRadius: '12px', border: 'none', fontWeight: '600', cursor: 'pointer',
              fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 6L9 17l-5-5"/>
              </svg>
              <span>Proceed</span>
            </button>
            <button onClick={onCancel} style={{
              padding: '12px 24px', border: '2px solid #e5e7eb', backgroundColor: 'white',
              color: '#374151', borderRadius: '12px', fontWeight: '600', cursor: 'pointer', fontSize: '16px'
            }}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// CKYC Confirmation Modal Component
const CkycConfirmationModal = ({ isOpen, onConfirm, onCancel, mobileNumber, refNumber, errorMessage }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        maxWidth: '480px',
        width: '100%',
        transform: 'scale(1)',
        transition: 'all 0.3s ease'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px',
          borderBottom: '1px solid #f1f5f9'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9 12l2 2 4-4"/>
              </svg>
            </div>
            <div>
              <h2 style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#1f2937', 
                margin: 0 
              }}>
                CKYC Verification Confirmation
              </h2>
              <p style={{ 
                fontSize: '14px', 
                color: '#6b7280',
                margin: '4px 0 0 0'
              }}>
                Confirm to proceed with verification
              </p>
            </div>
          </div>
          <button
            onClick={onCancel}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          {errorMessage ? (
            <div style={{
              padding: '16px',
              backgroundColor: '#fef2f2',
              borderRadius: '12px',
              border: '1px solid #fecaca',
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              <p style={{ color: '#b91c1c', fontWeight: '600', fontSize: '15px', margin: 0 }}>{errorMessage}</p>
            </div>
          ) : (
          <>
          {/* Ref Number Display */}
          {refNumber && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'flex-start', 
              gap: '12px', 
              marginBottom: '24px',
              padding: '16px',
              backgroundColor: '#f0f9ff',
              borderRadius: '12px',
              border: '1px solid #bae6fd'
            }}>
              <div style={{
                width: '32px',
                height: '32px',
                backgroundColor: '#e0f2fe',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3 3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                </svg>
              </div>
              <div>
                <p style={{ 
                  color: '#0c4a6e', 
                  fontWeight: '600', 
                  marginBottom: '8px', 
                  fontSize: '16px' 
                }}>
                  CKYC Number Found
                </p>
                <p style={{ 
                  color: '#0c4a6e', 
                  fontSize: '14px', 
                  lineHeight: '1.5',
                  margin: 0 
                }}>
                  CKYC No: <strong>{refNumber}</strong>
                </p>
              </div>
            </div>
          )}

          {/* Information Message */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            gap: '12px', 
            marginBottom: '24px',
            padding: '16px',
            backgroundColor: '#eff6ff',
            borderRadius: '12px',
            border: '1px solid #bfdbfe'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              backgroundColor: '#dbeafe',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              marginTop: '2px'
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
            </div>
            <div>
              <p style={{ 
                color: '#1e40af', 
                fontWeight: '600', 
                marginBottom: '8px', 
                fontSize: '16px' 
              }}>
                OTP Verification Required
              </p>
              <p style={{ 
                color: '#1e40af', 
                fontSize: '14px', 
                lineHeight: '1.5',
                margin: 0 
              }}>
                On clicking "Proceed", an OTP will be sent to your registered mobile number for CKYC verification.
              </p>
            </div>
          </div>
          </>
          )}
          {/* Actions */}
          <div style={{ display: 'flex', gap: '12px' }}>
            {!errorMessage && (
            <button
              onClick={onConfirm}
              style={{
                flex: 1,
                backgroundColor: '#D32028',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '12px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#D32028'}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              <span>Send OTP</span>
            </button>
            )}
            {!errorMessage && (
            <button
              onClick={onCancel}
              style={{
                padding: '12px 24px',
                border: '2px solid #e5e7eb',
                backgroundColor: 'white',
                color: '#374151',
                borderRadius: '12px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '16px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.borderColor = '#d1d5db';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.borderColor = '#e5e7eb';
              }}
            >
              Cancel
            </button>
            )}
          </div>

          {!errorMessage && (
          <div style={{
            marginTop: '16px',
            padding: '12px',
            backgroundColor: '#fefce8',
            borderRadius: '12px',
            border: '1px solid #fde047'
          }}>
            <p style={{ 
              fontSize: '12px', 
              color: '#854d0e', 
              textAlign: 'center', 
              margin: 0,
              lineHeight: '1.4'
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '4px', verticalAlign: 'text-bottom' }}>
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                <path d="M12 9v4"/>
                <path d="M12 17h.01"/>
              </svg>
              Please ensure your mobile number is active and you can receive SMS messages.
            </p>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Modern CKYC Modal Component
const ModernCKYCModal = ({
  isOpen,
  onClose,
  modalMessage,
  requiresOtpInput,
  otpInput,
  setOtpInput,
  onOtpSubmit,
  isLoading,
  apiError,
  onRetry,
  canRetry = true,
  onResendOtp,       // New prop for resend action
  resendOtpTimer     // New prop for timer display
}) => {
  if (!isOpen) return null;

  // Determine the current step based on props
  const getStep = () => {
    if (modalMessage === 'CKYC download successful!' || modalMessage?.includes('successful')) {
      return 'success';
    } else if (requiresOtpInput) {
      return 'otp';
    } else {
      return 'error';
    }
  };

  const step = getStep();

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 6) {
      setOtpInput(value);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        maxWidth: '480px',
        width: '100%',
        transform: 'scale(1)',
        transition: 'all 0.3s ease'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px',
          borderBottom: '1px solid #f1f5f9'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: step === 'error' ? '#fee2e2' : 
                        step === 'success' ? '#dcfce7' : 
                        'linear-gradient(135deg, #D32028 0%, #b91c1c 100%)'
            }}>
              {step === 'error' ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
                </svg>
              ) : step === 'success' ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/><path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/><path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                </svg>
              )}
            </div>
            <div>
              <h2 style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#1f2937', 
                margin: 0 
              }}>
                CKYC Verification
              </h2>
              <p style={{ 
                fontSize: '14px', 
                color: step === 'error' ? '#ef4444' : 
                       step === 'success' ? '#16a34a' : '#6b7280',
                margin: '4px 0 0 0'
              }}>
                {step === 'error' ? 'Verification failed' : 
                 step === 'success' ? 'Verification complete' : 'Secure identity verification'}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={isLoading}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          {step === 'otp' && (
            <>
              {/* OTP Message */}
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '24px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: '#dcfce7',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: '2px'
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <div>
                  <p style={{ color: '#1f2937', fontWeight: '500', marginBottom: '4px', fontSize: '16px' }}>
                    {modalMessage}
                  </p>
                  <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
                    OTP sent to your registered mobile number.
                  </p>
                </div>
              </div>

              {/* OTP Input */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#374151', 
                  marginBottom: '12px' 
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><circle cx="12" cy="16" r="1"/><path d="m7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <span>Enter 6-digit OTP</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    value={otpInput}
                    onChange={handleOtpChange}
                    maxLength="6"
                    placeholder="000000"
                    disabled={isLoading}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      fontSize: '18px',
                      fontFamily: 'monospace',
                      letterSpacing: '0.25em',
                      textAlign: 'center',
                      border: `2px solid ${apiError ? '#ef4444' : '#e5e7eb'}`,
                      borderRadius: '12px',
                      outline: 'none',
                      transition: 'all 0.2s',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => {
                      if (!apiError) {
                        e.target.style.borderColor = '#D32028';
                        e.target.style.boxShadow = '0 0 0 3px rgba(211, 32, 40, 0.1)';
                      }
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = apiError ? '#ef4444' : '#e5e7eb';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {otpInput.length === 6 && (
                    <div style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)'
                    }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/>
                      </svg>
                    </div>
                  )}
                </div>
                {apiError && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', color: '#dc2626' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <span style={{ fontSize: '14px' }}>{apiError}</span>
                  </div>
                )}
              </div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={onOtpSubmit}
                  disabled={isLoading || otpInput.length !== 6}
                  style={{
                    flex: 1,
                    backgroundColor: '#D32028',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.2s',
                    opacity: (isLoading || otpInput.length !== 6) ? 0.5 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!isLoading && otpInput.length === 6) {
                      e.target.style.backgroundColor = '#b91c1c';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#D32028';
                  }}
                >
                  {isLoading ? (
                    <>
                      <div style={{
                        width: '20px',
                        height: '20px',
                        border: '2px solid white',
                        borderTopColor: 'transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}></div>
                      <span>Verifying...</span>
                    </>
                  ) : (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 12l2 2 4-4"/><path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/><path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                      </svg>
                      <span>Verify OTP</span>
                    </>
                  )}
                </button>
                <button
                  onClick={onClose}
                  disabled={isLoading}
                  style={{
                    padding: '12px 24px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: 'white',
                    color: '#374151',
                    borderRadius: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px',
                    transition: 'all 0.2s',
                    opacity: isLoading ? 0.5 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!isLoading) {
                      e.target.style.backgroundColor = '#f9fafb';
                      e.target.style.borderColor = '#d1d5db';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.borderColor = '#e5e7eb';
                  }}
                >
                  Cancel
                </button>
              </div>

              {/* Helper Text */}
              <div style={{
                marginTop: '16px',
                padding: '12px',
                backgroundColor: '#fef2f2',
                borderRadius: '12px'
              }}>
                <p style={{ 
                  fontSize: '14px', 
                  color: '#b91c1c', 
                  textAlign: 'center', 
                  margin: 0 
                }}>
                  Didn't receive OTP? <button 
                    onClick={onResendOtp} // Call the passed resend handler
                    disabled={isLoading || resendOtpTimer > 0} // Disable if loading or timer is running
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      color: '#b91c1c', 
                      fontWeight: '600', 
                      textDecoration: 'underline', 
                      cursor: 'pointer',
                      fontSize: '14px',
                      opacity: (isLoading || resendOtpTimer > 0) ? 0.5 : 1 // Dim when disabled
                    }}
                    onMouseEnter={(e) => {
                        if (!isLoading && resendOtpTimer === 0) e.target.style.textDecoration = 'none';
                    }}
                    onMouseLeave={(e) => {
                        if (!isLoading && resendOtpTimer === 0) e.target.style.textDecoration = 'underline';
                    }}
                  >
                    {resendOtpTimer > 0 ? `Resend OTP in ${resendOtpTimer}s` : 'Resend OTP'}
                  </button>
                </p>
              </div>
            </>
          )}

          {step === 'error' && (
            <div style={{ textAlign: 'center', paddingTop: '16px', paddingBottom: '16px' }}>
              <div style={{
                width: '64px',
                height: '64px',
                backgroundColor: '#fee2e2',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
                </svg>
              </div>
              <h3 style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#1f2937', 
                marginBottom: '8px' 
              }}>
                Verification Failed
              </h3>
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '24px'
              }}>
                <p style={{ 
                  color: '#b91c1c', 
                  fontSize: '14px', 
                  lineHeight: 1.5, 
                  margin: 0 
                }}>
                  {modalMessage}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                {canRetry && (
                <button
                  onClick={onRetry}
                  style={{
                    flex: 1,
                    backgroundColor: '#D32028',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px',
                    transition: 'opacity 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                  onMouseLeave={(e) => e.target.style.opacity = '1'}
                >
                  Try Again
                </button>
                )}
                <button
                  onClick={onClose}
                  style={{
                    padding: '12px 24px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: 'white',
                    color: '#374151',
                    borderRadius: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f9fafb';
                    e.target.style.borderColor = '#d1d5db';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.borderColor = '#e5e7eb';
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {step === 'success' && (
            <div style={{ textAlign: 'center', paddingTop: '16px', paddingBottom: '16px' }}>
              <div style={{
                width: '64px',
                height: '64px',
                backgroundColor: '#dcfce7',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/>
                </svg>
              </div>
              <h3 style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#1f2937', 
                marginBottom: '8px' 
              }}>
                Verification Successful!
              </h3>
              <p style={{ 
                color: '#6b7280', 
                marginBottom: '24px', 
                fontSize: '16px' 
              }}>
                Your CKYC verification has been completed successfully.
              </p>
              <button
                onClick={onClose}
                style={{
                  width: '100%',
                  background: 'linear-gradient(135deg, #16a34a 0%, #059669 100%)',
                  color: 'white',
                  padding: '12px 16px',
                  borderRadius: '12px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Continue
              </button>
            </div>
          )}
        </div>
      </div>
      
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default function KycProfile({ profileDetails, currapplicationId, curruserId, shouldFetchData = true }) {
  const user = null
  const panProState = useSelector((state) => state?.PANPRO?.panStatus?.res);
  const panState = useSelector((state) => state?.PAN?.panStatus?.res);
  const { status } = useSelector(state => state.appContext);
  const [imageOpen, setImageOpen] = useState(false);
  const [panProDetails, setPanProDetails] = useState(null)
  const dispatch = useDispatch();

  const [kycDetails, setCkycDetails] = useState(null)
  const [panDetails, setPanDetails] = useState(null)
  const [digilockerDetails, setDigiLockerDetails] = useState(null)
  const [addressProofDetails, setAddressProofDetails] = useState([])
  const [bankVerificationDetails, setBankSelfieDetails] = useState(null)

  // CKYC Trigger States
  const [showCkycModal, setShowCkycModal] = useState(false);
  const [ckycModalMessage, setCkycModalMessage] = useState('');
  const [ckycCanRetry, setCkycCanRetry] = useState(true);
  const [ckycRequiresOtpInput, setCkycRequiresOtpInput] = useState(false);
  const [otpInput, setOtpInput] = useState('');
  const [currentCkycRequestId, setCurrentCkycRequestId] = useState(null);
  const [currentCkycRefNumber, setCurrentCkycRefNumber] = useState(null);
  const [isCkycLoading, setIsCkycLoading] = useState(false);
  const [ckycApiError, setCkycApiError] = useState('');
  
  // New state for Resend OTP timer
  const [resendOtpTimer, setResendOtpTimer] = useState(0);
  const RESEND_COOLDOWN_SECONDS = 45;
  const timerRef = useRef(null); // To store interval ID

  // Face Match States
  const [showCkycConfirmationModal, setShowCkycConfirmationModal] = useState(false);
  const [ckycConfirmError, setCkycConfirmError] = useState('');
  const [showFaceMatchConfirmationModal, setShowFaceMatchConfirmationModal] = useState(false);
  const [isFaceMatchLoading, setIsFaceMatchLoading] = useState(false);
  const [isInitiateCkycLoading, setIsInitiateCkycLoading] = useState(false);
  const [showInitiateCkycConfirmModal, setShowInitiateCkycConfirmModal] = useState(false);

  const DocumentTypeArray = ["", "Proof of Identity", "Proof of Address"]
  const DocumentArray = ["", "Aadhaar", "Pan"]
  const VerificationMethodArray = [
    "",
    "Digio OCR",
    "Digi locker",
    "Zoop Service",
    "TransUnion",
    "pan pro",
    "",
    "Digio pan"
  ]

  // These URLs depend on curruserId and currapplicationId
  const panUrl = `/application/pan-details?userId=${curruserId}&applicationId=${currapplicationId}`;
  const ckycUrl = `/ckyc/details?userId=${curruserId}`;
  const bankSelfieUrl = `/integrations/details?applicationId=${currapplicationId}&userId=${curruserId}`;
  const digilockerUrl = `/digilocker/details?applicationId=${currapplicationId}&userId=${curruserId}`;
  const addressProofUrl = `/address-details?userId=${curruserId}&applicationId=${currapplicationId}`;
  // Memoize fetchData with useCallback
  // Dependencies include props and user data from sessionStorage that it uses.
  // State setters (setCkycDetails, etc.) are stable and do not need to be in the dependency array.
  const fetchData = useCallback(async () => {
    if (!shouldFetchData) return;  
    
    const controller = new AbortController();
    try {
      // Use Promise.allSettled so one failing request doesn't block the others
      const requests = [
        axiosInstance.get(ckycUrl),
        axiosInstance.get(bankSelfieUrl),
        axiosInstance.get(panUrl),
        axiosInstance.get(digilockerUrl),
        axiosInstance.get(addressProofUrl),
      ];

      const results = await Promise.allSettled(requests);

      const ckycResult = results[0];
      const bankSelfieResult = results[1];
      const panResult = results[2];
      const digiLockerResult = results[3];
      const addressProofResult = results[4];

      if (addressProofResult.status === 'fulfilled') {
        setAddressProofDetails(addressProofResult.value?.data?.data || []);
      } else {
        console.error('addressProof request failed:', addressProofResult.reason);
        setAddressProofDetails([]);
      }

      if (ckycResult.status === 'fulfilled') {
        setCkycDetails(ckycResult.value?.data?.data?.response);
      } else {
        console.error('ckyc request failed:', ckycResult.reason);
        setCkycDetails(null);
      }

      if (bankSelfieResult.status === 'fulfilled') {
        setBankSelfieDetails(bankSelfieResult.value?.data?.data);
      } else {
        console.error('bankSelfie request failed:', bankSelfieResult.reason);
        setBankSelfieDetails(null);
      }

      if (panResult.status === 'fulfilled') {
        setPanDetails(panResult.value?.data?.data?.[0] || null);
      } else {
        console.error('pan request failed:', panResult.reason);
        setPanDetails(null);
      }

      if (digiLockerResult.status === 'fulfilled') {
        setDigiLockerDetails(digiLockerResult.value?.data?.data);
      } else {
        console.error('digilocker request failed:', digiLockerResult.reason);
        setDigiLockerDetails(null);
      }
    } catch (err) {
      if (err.name !== 'CanceledError') {
        console.error("Failed to fetch data:", err);
      }
    }
  }, [user, curruserId, currapplicationId, ckycUrl, bankSelfieUrl, panUrl, digilockerUrl,addressProofUrl, shouldFetchData]);
  

  useEffect(() => {
    if (panProDetails?.status === "valid" || panState?.status === "valid") { 
      // This might be better handled by a direct dispatch after pan verification success.
      // Keeping it as is, but noting potential for improvement.
      // dispatch(userActions.getPanStatus(panUrl)); 
    }
  }, [panProDetails, panState, dispatch])

  useEffect(() => {
    // Call fetchData when it changes (due to its dependencies changing) or on mount
    if (shouldFetchData) {
      fetchData();
    }
  }, [fetchData, shouldFetchData]); // Dependency is now fetchData itself, which is memoized by useCallback.

  // Effect to manage the resend OTP timer
  useEffect(() => {
    if (resendOtpTimer > 0) {
      timerRef.current = setInterval(() => {
        setResendOtpTimer(prev => prev - 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    // Cleanup on component unmount or timer reset
    return () => clearInterval(timerRef.current);
  }, [resendOtpTimer]);

  const retriggerDigioPanPro = () => {
    const url = '/digio-pan/verify'
    const data = {
      pan: profileDetails?.panId,
      // Concatenate names carefully to avoid "undefined Name"
      name: `${profileDetails?.firstName || ''} ${profileDetails?.lastName || ''}`.trim().toUpperCase(),
      dob: profileDetails?.dateOfBirth,
      userId: profileDetails?.userId,
      applicationId: currapplicationId,
      address: profileDetails?.currentAddress,
      instituteId: profileDetails?.instituteId,
      productType: profileDetails?.productType,
      isCoapplicant: Number(profileDetails?.isCoapplicant) === 1 ? 1 : 0
    }
    axiosInstance.post(url, data).then(res => {
      if (res.data.message === 'Successful') {
        alert('Retriggered successfully')
        window.location.reload()
      }
    }).catch(err => err)
  }

  const [itemPath, setitemPath] = useState(null)
  const handleClick = (item) => {
    const url = `/file/url-content?path=${item}`
    axiosInstance
      .get(url, {
        headers: {
        },
      })
      .then((res) => {
        setitemPath(res?.data?.data)
        if (res?.data?.data) {
          window.open(res?.data?.data, '_blank');
        }
      })
      .catch((error) => error)
  }

  // Helper function to start the resend timer
  const startResendTimer = () => {
    setResendOtpTimer(RESEND_COOLDOWN_SECONDS);
  };

  const handleTriggerCkycButtonClick = async () => {
    setCkycRequiresOtpInput(false);
    setOtpInput('');
    setCurrentCkycRequestId(null);
    setCkycApiError('');
    setResendOtpTimer(0);
    setCkycConfirmError('');

    setIsCkycLoading(true);
    try {
      const response = await axiosInstance.post('/ckyc/request', {
        userId: curruserId,
        applicationId: currapplicationId,
      }, { headers: { Authorization: `Bearer ${user}` } });

      if (response.data.message === 'Successful' && response.data.data) {
        if (response.data.data.success === false) {
          setCkycConfirmError(response.data.data.error_message || 'No record found');
          setCurrentCkycRefNumber(null);
          setShowCkycConfirmationModal(true);
          return;
        }
        const refNumber = response.data.data.refNumber || kycDetails?.ckycNo;
        if (!refNumber) {
          setCkycConfirmError('CKYC number not found.');
          setCurrentCkycRefNumber(null);
          setShowCkycConfirmationModal(true);
          return;
        }
        setCurrentCkycRefNumber(refNumber);
        setShowCkycConfirmationModal(true);
      } else {
        setCkycConfirmError(response.data.message || 'Failed to initiate CKYC.');
        setCurrentCkycRefNumber(null);
        setShowCkycConfirmationModal(true);
      }
    } catch (error) {
      setCkycConfirmError(error.response?.data?.message || error.message || 'Error initiating CKYC.');
      setCurrentCkycRefNumber(null);
      setShowCkycConfirmationModal(true);
    } finally {
      setIsCkycLoading(false);
    }
  };

  const handleTriggerFaceMatchButtonClick = () => {
    setShowFaceMatchConfirmationModal(true);
  };

  const handleInitiateCkyc = () => {
    setShowInitiateCkycConfirmModal(true);
  };

 const handleInitiateCkycConfirm = async () => {
  setShowInitiateCkycConfirmModal(false);
  setIsInitiateCkycLoading(true);

  try {
    const response = await axiosInstance.post('/ckyc/request', {
      userId: curruserId,
      panNumber: profileDetails?.panId,
    });

    if (
      response.data.message === "Successful" &&
      response.data.data?.success === true
    ) {
      alert("CKYC initiated successfully!");
      fetchData();
    } else {
      alert(response.data.data?.error_message || "No record found");
    }

  } catch (error) {
    alert(
      "Error initiating CKYC: " +
      (error.response?.data?.message || "Unknown error")
    );
  } finally {
    setIsInitiateCkycLoading(false);
  }
};
  const handleInitiateCkycCancel = () => {
    setShowInitiateCkycConfirmModal(false);
  };

  const handleCkycConfirmationCancel = () => {
    setShowCkycConfirmationModal(false);
    setCkycConfirmError('');
  };

  const handleFaceMatchConfirmationCancel = () => {
    setShowFaceMatchConfirmationModal(false);
  };

  const handleFaceMatchConfirmation = async () => {
    setShowFaceMatchConfirmationModal(false);
    setIsFaceMatchLoading(true);

    try {
      const response = await axiosInstance.post(`/selfie/ckyc-facematch?applicationId=${currapplicationId}&userId=${curruserId}`);

      if (response.data.message === "Successful") {
        alert('Face match completed successfully!');
        fetchData(); // Refresh data
      }
    } catch (error) {
      console.error('Error in face match:', error);
      alert('Error in face match: ' + (error.response?.data?.message || 'Unknown error'));
    } finally {
      setIsFaceMatchLoading(false);
    }
  };

  // CKYC Functions
  const handleCkycConfirmation = async () => {
    setShowCkycConfirmationModal(false);
    await sendCkycOtp(currentCkycRefNumber);
  };

  const sendCkycOtp = async (ckycRefNumber) => {
    setIsCkycLoading(true);
    setCkycApiError(''); // Clear previous errors
    try {
      if (!profileDetails?.mobile) {
        throw new Error("User mobile number not available for OTP.");
      }
      const otpPayload = {
        ckycNumber: ckycRefNumber,
        mobile: profileDetails?.mobile, // Use actual user mobile number from props
      };
      const response = await axiosInstance.post('/ckyc/otp', otpPayload, {
      });

      if (response.data.message === "Successful" && response.data.data) {
        if (response.data.data.success === false) {
          setCkycModalMessage(response.data.data.error_message || 'No record found');
          setCkycRequiresOtpInput(false);
          setShowCkycModal(true);
          return;
        }
        setCurrentCkycRequestId(response.data.data.request_id);
        setCkycModalMessage(response.data.data.message);

        if (response.data.data.message?.includes('Download failed') || response.data.data.error_message) {
          setCkycRequiresOtpInput(false);
        } else {
          setCkycRequiresOtpInput(true);
          startResendTimer(); // Start timer after OTP is sent successfully
        }
        setShowCkycModal(true);
      } else {
        setCkycModalMessage(response.data.message || 'Failed to send OTP. Please ensure your mobile number is correct.');
        setShowCkycModal(true);
      }
    } catch (error) {
      console.error('Error sending CKYC OTP:', error);
      setCkycModalMessage(error.message || error.response?.data?.message || 'Error sending CKYC OTP.');
      setShowCkycModal(true);
    } finally {
      setIsCkycLoading(false);
    }
  };

  const handleCkycOtpSubmit = async () => {
    if (otpInput.length !== 6) {
      setCkycApiError('Please enter a valid 6-digit OTP.');
      return;
    }
    setIsCkycLoading(true);
    setCkycApiError('');

    try {
      if (!profileDetails?.mobile) {
        throw new Error("User mobile number not available for OTP verification.");
      }
      const downloadPayload = {
        mobile: profileDetails.mobile, // Use actual user mobile number from props
        otp: otpInput,
        requestId: currentCkycRequestId,
      };
      const response = await axiosInstance.post('/admin/application/download-ckyc', downloadPayload, {
      });

      if (response.data.message === "Successful") {
        setCkycModalMessage('CKYC download successful!');
        setCkycRequiresOtpInput(false);
        setOtpInput('');
        fetchData(); // Refresh data to show CKYC status
        setResendOtpTimer(0); // Stop timer on successful verification
      } else {
        setCkycApiError(response.data.message || 'Failed to verify OTP or download CKYC.');
      }
    } catch (error) {
      console.error('Error downloading CKYC:', error);
      setCkycApiError(error.message || error.response?.data?.message || 'Error verifying OTP or downloading CKYC.');
    } finally {
      setIsCkycLoading(false);
    }
  };

  // New function for Resending OTP
  const handleResendCkycOtp = async () => {
    if (resendOtpTimer > 0) { // Double check to prevent multiple rapid clicks
      return;
    }
    if (!currentCkycRefNumber || !profileDetails?.mobile) {
      setCkycApiError('Cannot resend OTP. Missing CKYC reference or mobile number.');
      return;
    }
    // Clear the OTP input field for a fresh entry
    setOtpInput('');
    // Re-use sendCkycOtp function, it will handle starting the timer again
    await sendCkycOtp(currentCkycRefNumber);
  };

  const handleRetry = () => {
    // Reset all CKYC states for a fresh attempt
    setCkycModalMessage('');
    setCkycRequiresOtpInput(false);
    setOtpInput('');
    setCurrentCkycRequestId(null);
    setCurrentCkycRefNumber(null);
    setIsCkycLoading(false);
    setCkycApiError('');
    setResendOtpTimer(0); // Reset timer on retry
    fetchData(); // Call fetchData on retry
    handleTriggerCkycButtonClick(); // Re-initiate the entire flow
  };

  const closeCkycModal = () => {
    setShowCkycModal(false);
    setCkycModalMessage('');
    setCkycRequiresOtpInput(false);
    setOtpInput('');
    setCurrentCkycRequestId(null);
    setCurrentCkycRefNumber(null);
    setIsCkycLoading(false);
    setCkycApiError('');
    setResendOtpTimer(0); // Reset timer when modal closes
  };

  const [showBankVerifyModal, setShowBankVerifyModal] = useState(false);
  const [bankAccountNumber, setBankAccountNumber] = useState('');
  const [bankIfscCode, setBankIfscCode] = useState('');
  const [verifiedBeneficiaryName,setVerifiedBeneficiaryName] = useState("");
  const [bankVerificationStatus, setBankVerificationStatus] = useState(null);
  const [loading,setLoading] = useState(false)
  const handleBankVerify = async () => {
  setLoading(true)
  
  try {
    const downloadPayload = {
      accountNumber: bankAccountNumber,
      ifscCode: bankIfscCode,
      userId: profileDetails?.userId,
      applicationId: profileDetails?.applicationId
    };
    
    const response = await axiosInstance.post('/bank-account-verification/verify-pl', downloadPayload, {
    });
       
    if (response?.data?.status == 1) {
      setVerifiedBeneficiaryName(response?.data?.beneficiaryName);
      setBankVerificationStatus('success');
      alert('Bank verification successful!');
      setLoading(false)
    } else {
      setBankVerificationStatus('failed');
      setVerifiedBeneficiaryName('');
      alert('Bank verification failed!');
      setLoading(false)
    }
  } catch (error) {
    console.error('Bank verification error:', error);
    setBankVerificationStatus('failed');
    setVerifiedBeneficiaryName('');
    alert('Bank verification failed!');
    setLoading(false)
  }
};

  return (
    <div style={{ display: 'block', paddingBottom: '12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '2em', marginLeft: '1em' }}>
        <div style={{ borderRadius: '1em', width: '50%', margin: '1em', boxShadow: '0px 0px 2px 2px  #f0f0f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5em 1em', width: '100%', borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Outfit', alignItems: 'center' }}>
                <img style={{ marginRight: '0.5em', width: '25px' }} src={bankImg} />Bank Verification
              </span>
              <span>
                  {bankVerificationDetails?.bankDetails?.verificationStatus === "VERIFIED" ? 
                    <img src={successful} style={{ width: '100px' }} /> : 
                    <img src={attention} style={{ width: '100px' }} />}
                </span>
                {profileDetails?.instituteName === "Personal Loan" ? 
              <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <button
                  onClick={() => setShowBankVerifyModal(true)}
                  style={{
                    backgroundColor: '#D32028',
                    color: 'white',
                    padding: '0px 8px 0px 8px',
                    borderRadius: '8px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#D32028'}
                >
                  Verify Bank
                </button>
                
              </div>
              </>
              :null}
            </div>
          </div>
          <div style={{ padding: '0.5em 1em', paddingLeft: '1em', lineHeight: 2, fontSize: '16px' }}>
            <div>
              <p style={{ color: '#667085' }}>Beneficiary Name</p>
              <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.bankDetails?.beneficiaryName}</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Account Number</p>
                <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.bankDetails?.accountNumber}</p>
              </div>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>IFSC Code</p>
                <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.bankDetails?.ifsc}</p>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Name Match Score</p>
                <p style={{ 
                  borderRadius: '1em', 
                  width: '3.5em', 
                  textAlign: 'center', 
                  fontWeight: 'bold', 
                  color: bankVerificationDetails?.bankDetails?.matchPercentage > 65 ? 'green' : 'red', 
                  backgroundColor: bankVerificationDetails?.bankDetails?.matchPercentage > 65 ? '#ECFDF3' : '#FFF6E8' 
                }}>
                  {Math.round(bankVerificationDetails?.bankDetails?.matchPercentage)} %
                </p>
              </div>
            </div>
          </div>
        </div>

        <div style={{ borderRadius: '1em', width: '50%', margin: '1em', boxShadow: '0px 0px 2px 2px  #f0f0f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5em 1em', width: '100%', borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ fontSize: '18px', fontWeight: 'bold', fontFamily: 'Outfit' }}>
                <img style={{ marginRight: '0.5em', width: '25px' }} src={faceLive} />Face Match
              </span>
              <span>
                {bankVerificationDetails?.selfieDetails?.facematchScore >= "100" ? 
                  <img src={successful} style={{ width: '100px' }} /> : 
                  <img src={attention} style={{ width: '100px' }} />}
              </span>
            </div>
          </div>
          <div style={{ padding: '1em', height: 'fit-content' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Digilocker Match</p>
                <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.selfieDetails?.facematchScore} %</p>
              </div>
              {bankVerificationDetails?.selfieDetails?.ckycFacematchScore != null && (
                <div style={{ display: 'block' }}>
                  <p style={{ color: '#667085' }}>CKYC Match</p>
                  <p style={{ fontWeight: 'bold' }}>
                    {bankVerificationDetails?.selfieDetails?.ckycFacematchScore} %
                  </p>
                </div>
              )}
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Accuracy</p>
                <p style={{ fontWeight: 'bold' }}>{Math.round(bankVerificationDetails?.selfieDetails?.geoTagAccuracy)}</p>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>latitude</p>
                <p style={{ fontWeight: 'bold' }}>{Math.round(bankVerificationDetails?.selfieDetails?.geoTagLatitude * 1000000) / 1000000}</p>
              </div>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Longitude</p>
                <p style={{ fontWeight: 'bold' }}>{Math.round(bankVerificationDetails?.selfieDetails?.geoTagLongitude * 1000000) / 1000000}</p>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>
                  Geo-Address
                  <a href={`https://maps.google.com/maps?q=${bankVerificationDetails?.selfieDetails?.geoTagLatitude},${bankVerificationDetails?.selfieDetails?.geoTagLongitude}&hl=es;z=14&amp;output=embed`}
                    style={{ color: 'inherit', backgroundColor: 'aliceBlue', textAlign: "left", textDecoration: 'underline', marginLeft: '1em', fontWeight: 'bold' }}
                    target="_blank"
                    rel='noreferrer'>Open Map</a> <img src={openMap} />
                </p>
                <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.selfieDetails?.geoTagAddress}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '2em', marginLeft: '1em', marginBottom: '0.5em' }}>
        <div style={{ borderRadius: '1em', width: '50%', margin: '1em', boxShadow: '0px 0px 2px 2px  #f0f0f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', borderBottom: '1px solid #f0f0f0', alignItems: 'center', padding: '0.5em 1em' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                <img style={{ marginRight: '0.5em', width: '25px' }} src={panImage} />PAN Verification
              </span>
              <span>
                {panState?.status === "valid" ? 
                  <img src={successful} style={{ width: '100px' }} /> : 
                  <div>
                    <img src={attention} style={{ width: '100px' }} />
                    <br />
                    <span style={{ color: '#D32028', fontWeight: 'bold', fontFamily: 'Inter-Medium', marginLeft: '5px', fontSize: '16px' }}>
                      {panState?.status}
                    </span>
                  </div>
                }
              </span>
              {status === "In Review" || "In Process" ? (
                <>
                  {panState?.status !== "valid" && 
                    <p style={{ 
                      backgroundColor: '#D32028', 
                      color: 'white', 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      borderRadius: '8px', 
                      paddingLeft: '10px', 
                      paddingRight: '10px', 
                      cursor: 'pointer', 
                      fontSize: '14px' 
                    }} onClick={retriggerDigioPanPro}>
                      Retrigger Pan
                    </p>
                  }
                </>
              ) : null}
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, padding: '1em' }}>
            <div>
              <p style={{ color: '#667085' }}>Document Type</p>
              <p style={{ fontWeight: 'bold' }}>{DocumentTypeArray[panDetails?.documentType]}</p>
            </div>
            <div>
              <p style={{ color: '#667085' }}>Verification Method</p>
              <p style={{ fontWeight: 'bold' }}>
                {panProDetails ? 
                  VerificationMethodArray[panProDetails?.verificationMethod] : 
                  VerificationMethodArray[panDetails?.verificationMethod]
                }
              </p>
            </div>
          </div>
          {panProDetails ? (
            <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, padding: '0em 1em' }}>
              <div>
                <p style={{ color: '#667085' }}>Name</p>
                <p style={{ fontWeight: 'bold' }}>{panProDetails?.name}</p>
              </div>
              <div>
                <p style={{ color: '#667085' }}>Date of birth</p>
                <p style={{ fontWeight: 'bold' }}>{panProDetails?.dob}</p>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, padding: '0em 1em' }}>
              <div>
                <p style={{ color: '#667085' }}>Name</p>
                <p style={{ fontWeight: 'bold' }}>{panDetails?.name}</p>
              </div>
              <div>
                <p style={{ color: '#667085' }}>Date of birth</p>
                <p style={{ fontWeight: 'bold' }}>{panDetails?.dob}</p>
              </div>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, padding: '0em 1em' }}>
            {panProDetails ? (
              <div>
                <p style={{ color: '#667085' }}>Name Match Score</p>
                <p style={{ 
                  borderRadius: '1em', 
                  width: '3.5em', 
                  textAlign: 'center', 
                  fontWeight: 'bold', 
                  color: panProDetails?.nameMatchScore > 65 ? 'green' : 'red', 
                  backgroundColor: panProDetails?.nameMatchScore > 65 ? '#ECFDF3' : '#FFF6E8' 
                }}>
                  {Math.round(panProDetails?.nameMatchScore)} %
                </p>
              </div>
            ) : (
              <div>
                <p style={{ color: '#667085' }}>Name Match Score</p>
                <p style={{ 
                  borderRadius: '1em', 
                  width: '3.5em', 
                  textAlign: 'center', 
                  fontWeight: 'bold', 
                  color: panDetails?.nameMatchScore > 65 ? 'green' : 'red', 
                  backgroundColor: panDetails?.nameMatchScore > 65 ? '#ECFDF3' : '#FFF6E8' 
                }}>
                  {Math.round(panDetails?.nameMatchScore)} %
                </p>
              </div>
            )}
            <div>
              <p style={{ color: '#667085' }}>Aadhar Linked Status</p>
              <p style={{ fontWeight: 'bold' }}>{panDetails?.status}</p>
            </div>
          </div>
        </div>

        <div style={{ borderRadius: '1em', width: '50%', margin: '1em', boxShadow: '0px 0px 2px 2px  #f0f0f0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5em 1em', width: '100%', borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Outfit' }}>
                <img style={{ marginRight: '0.5em', width: '25px' }} src={faceMatch} />Face Liveness
              </span>
              <span>
                {digilockerDetails?.videoDetails?.otpScore <= "70" ? 
                  <img src={attention} style={{ width: '100px' }} /> : 
                  <img src={successful} style={{ width: '100px' }} />}
              </span>
            </div>
          </div>
          <div style={{ padding: '1em' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px' }}>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Face Liveness (%)</p>
                <p style={{ fontWeight: 'bold' }}>{((bankVerificationDetails?.selfieDetails?.faceLivenessScore) * 100).toFixed(2)}</p>
              </div>
              <div style={{ display: 'block' }}>
                <p style={{ color: '#667085' }}>Face Liveness Result</p>
                <p style={{ fontWeight: 'bold' }}>{bankVerificationDetails?.selfieDetails?.faceLivenessResult}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ borderRadius: '1em', width: '95%', marginLeft: '2em', boxShadow: '0px 0px 2px 2px  #f0f0f0', marginRight: '2em' }}>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5em 1em', width: '100%', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Outfit' }}>
                <img style={{ marginRight: '0.5em', width: '25px' }} src={frame} />ID Verification
                <img style={{ marginLeft: '1em', width: '65px' }} src={ckyckImage} />
              </span>
              <>
                <button
                  onClick={handleInitiateCkyc}
                  disabled={isInitiateCkycLoading}
                  style={{
                    marginLeft: '0.75em',
                    borderRadius: '6px',
                    padding: '0 10px',
                    height: '28px',
                    backgroundColor: isInitiateCkycLoading ? '#f5a0a3' : '#D32028',
                    color: 'white',
                    border: 'none',
                    cursor: isInitiateCkycLoading ? 'not-allowed' : 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {isInitiateCkycLoading ? 'Processing...' : 'Initiate CKYC'}
                </button>
              </>
              <>
                <button
                  onClick={handleTriggerCkycButtonClick}
                  disabled={isCkycLoading}
                  style={{
                    marginLeft: '0.75em',
                    borderRadius: '6px',
                    padding: '0 10px',
                    height: '28px',
                    backgroundColor: isCkycLoading ? '#f5a0a3' : '#D32028',
                    color: 'white',
                    border: 'none',
                    cursor: isCkycLoading ? 'not-allowed' : 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {isCkycLoading ? 'Processing...' : 'Trigger CKYC OTP'}
                </button>
              </>
              <>
                <button
                  onClick={handleTriggerFaceMatchButtonClick}
                  disabled={isFaceMatchLoading}
                  style={{
                    marginLeft: '0.75em',
                    borderRadius: '6px',
                    padding: '0 10px',
                    height: '28px',
                    backgroundColor: isFaceMatchLoading ? '#f5a0a3' : '#D32028',
                    color: 'white',
                    border: 'none',
                    cursor: isFaceMatchLoading ? 'not-allowed' : 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {isFaceMatchLoading ? 'Processing...' : 'Trigger Face Match'}
                </button>
              </>
              
            
            </div>
            <span>
              {kycDetails?.ckycNo ? 
                <img src={successful} style={{ width: '100px' }} /> : 
                <img src={attention} style={{ width: '100px' }} />}
            </span>
          </div>
        </div>
        <div style={{ padding: '1em' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px' }}>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>C-KYC No</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.ckycNo} </p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Last Updated</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.kycDate}</p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>DOB</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.dateOfBirth} </p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Gender</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.gender} </p>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px' }}>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Name</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.fullName} </p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Father/Spouse Name</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.fatherName} </p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Mother Name</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.motherName} </p>
            </div>
            <div style={{ display: 'block', width: '12em' }}>
              <p style={{ color: '#667085' }}>Email ID</p>
              <p style={{ fontWeight: 'bold' }}>{kycDetails?.email} </p>
            </div>
          </div>
          <div style={{ display: 'flex', lineHeight: 2, fontSize: '16px' }}>
            <div style={{ width: '40%' }}>
              <p style={{ color: '#667085' }}>Permanent Address</p>
              <p style={{ fontWeight: 'bold', width: '90%' }}>
                {kycDetails?.permanentAddress?.length > 40 ? 
                  kycDetails?.permanentAddress?.substr(0, 50) : 
                  kycDetails?.permanentAddress}
              </p>
            </div>
            <div style={{ width: '40%' }}>
              <p style={{ color: '#667085' }}>Correspondence Address</p>
              <p title={kycDetails?.currentAddress} style={{ fontWeight: 'bold', width: '90%' }}>
                {kycDetails?.currentAddress?.length > 40 ? 
                  kycDetails?.currentAddress?.substr(0, 50) : 
                  kycDetails?.currentAddress}
              </p>
            </div>
            <div>
              <p style={{ color: '#667085' }}>Images Obtained</p>
              {kycDetails?.imageList?.map((item, index) => (
                <p key={index} style={{ fontWeight: 'bold' }}>
                  <ViewFile item={item?.imageUrl ? item?.imageUrl : null} image={viewBig} />
                  <br />
                  <small>{item?.type ? item?.type : null}</small>
                </p>
              ))}
            </div>
          </div>

          {digilockerDetails && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <p style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Outfit' }}>
                    <img style={{ marginRight: '0.5em', width: '25px' }} src={frame} />ID Verification
                    <img style={{ marginLeft: '1em', width: '100px' }} src={digilocker} />
                  </p>
                </div>
              </div>
              <div>
                <div style={{ marginBottom: '1em', display: 'block', marginTop: '0.5em' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px' }}>
                    <div style={{ display: "block" }}>
                      <p style={{ fontWeight: '700' }}>Aadhaar Number</p>
                      {digilockerDetails?.response?.response?.aadhaar?.id_number}
                    </div>
                    <div style={{ display: "block" }}>
                      <p style={{ fontWeight: '700' }}>Name</p>
                      {digilockerDetails?.response?.response?.aadhaar?.name}
                    </div>
                    <div style={{ display: "block" }}>
                      <p style={{ fontWeight: '700' }}>Gender</p>
                      {digilockerDetails?.response?.response?.aadhaar?.gender}
                    </div>
                    <div style={{ display: "block" }}>
                      <p style={{ fontWeight: '700' }}>Date Of Birth</p>
                      {digilockerDetails?.response?.response?.aadhaar?.dob}
                    </div>
                    <div style={{ display: "block" }}>
                      <p style={{ fontWeight: '700' }}>Image</p>
                      <p style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }} 
                        onClick={() => { handleClick(digilockerDetails?.response?.response?.aadhaar?.image) }}>
                        Click to See Image
                      </p>
                    </div>
                  </div>
                  <div>
                    <div style={{ display: 'flex', lineHeight: 2, fontSize: '16px' }}>
                      <div style={{ paddingTop: '1em' }}>
                        <p style={{ fontWeight: '700' }}>
                          Permanent Address:
                          <p style={{ width: '20em', fontWeight: '350', marginLeft: '10px' }}>
                            {digilockerDetails?.response?.response?.aadhaar?.permanent_address}
                            <br />
                          </p>
                        </p>
                      </div>
                      <div style={{ paddingTop: '1em', marginLeft: '1em' }}>
                        <p style={{ fontWeight: '700' }}>
                          Correspondence Address:
                          <p style={{ width: '20em', fontWeight: '350', marginLeft: '10px' }}>
                            {digilockerDetails?.response?.response?.aadhaar?.current_address}
                          </p>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <p style={{ border: '1px dashed #C0C0C0' }}></p>
         {addressProofDetails && addressProofDetails.length > 0 && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', borderBottom: '1px solid #f0f0f0', marginTop: '1em' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <p style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Outfit' }}>
                    <img style={{ marginRight: '0.5em', width: '25px' }} src={frame} />Address Proof Verification
                  </p>
                </div>
              </div>
              <div>
                {addressProofDetails.map((proof, index) => (
                  <div key={index} style={{ 
                    marginBottom: '1.5em', 
                    display: 'block', 
                    marginTop: '1em',
                    padding: '1em',
                    backgroundColor: '#f9fafb',
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: 2, fontSize: '16px', flexWrap: 'wrap' }}>
                      <div style={{ display: "block", minWidth: '150px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Document</p>
                        <p style={{ fontWeight: 'bold' }}>{proof?.document === 9 ?"Driving License" : proof?.document === 10 ? "Voter Id" : proof?.document === 11 ?"Passport":""}</p>
                      </div>
                      <div style={{ display: "block", minWidth: '150px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Document Type</p>
                        <p style={{ fontWeight: 'bold' }}>{DocumentTypeArray[proof?.documentType] || 'N/A'}</p>
                      </div>
                      <div style={{ display: "block", minWidth: '150px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Name</p>
                        <p style={{ fontWeight: 'bold' }}>{proof?.name || 'N/A'}</p>
                      </div>
                      {proof?.document != 11 && (
                        <>
                         <div style={{ display: "block", minWidth: '120px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Name Match Score</p>
                        <p style={{ 
                          borderRadius: '1em', 
                          width: '3.5em', 
                          textAlign: 'center', 
                          fontWeight: 'bold', 
                          color: (proof?.nameMatchScore || 0) > 65 ? 'green' : 'red', 
                          backgroundColor: (proof?.nameMatchScore || 0) > 65 ? '#ECFDF3' : '#FFF6E8',
                          padding: '4px'
                        }}>
                          {proof?.nameMatchScore ? Math.round(proof.nameMatchScore) : 0} %
                        </p>
                      </div>
                      <div style={{ display: "block", minWidth: '120px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Address Match Score</p>
                        <p style={{ 
                          borderRadius: '1em', 
                          width: '3.5em', 
                          textAlign: 'center', 
                          fontWeight: 'bold', 
                          color: (proof?.addressMatchScore || 0) > 65 ? 'green' : 'red', 
                          backgroundColor: (proof?.addressMatchScore || 0) > 65 ? '#ECFDF3' : '#FFF6E8',
                          padding: '4px'
                        }}>
                          {proof?.addressMatchScore ? Math.round(proof.addressMatchScore) : 0} %
                        </p>
                      </div>
                        </>
                      )}
                      {proof?.document == 11 && (
                        <div style={{ display: "block", minWidth: '150px' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Status</p>
                        <p style={{ fontWeight: 'bold' }}>{proof?.status || 'N/A'}</p>
                      </div>
                      )}
                     
                    </div>
                    {proof?.address && (
                      <div style={{ marginTop: '1em', paddingTop: '1em', borderTop: '1px solid #e5e7eb' }}>
                        <p style={{ fontWeight: '700', color: '#667085' }}>Address</p>
                        <p style={{ fontWeight: 'bold', lineHeight: '1.6', color: '#1f2937' }}>
                          {proof.address}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}

          <p style={{ border: '1px dashed #C0C0C0' }}></p>
          <p style={{ fontWeight: 'bold', fontSize: '16px', fontFamily: 'Outfit' }}>Documents Obtained</p>
          
          <div className="slides">
            {kycDetails?.identityList?.map((item, index) => (
              <div key={index} className="insideDiv">
                <img style={{ width: '5em', height: '5em', margin: '1em' }} src={documentImage} />
                <div style={{ lineHeight: '1em' }}>
                  <p style={{ marginLeft: '2em', fontFamily: 'Outfit' }}>{item.name}</p>
                  <p style={{ color: '#D32028', marginLeft: '2em' }}>{item.id}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showBankVerifyModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '16px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            maxWidth: '480px',
            width: '100%'
          }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '24px',
              borderBottom: '1px solid #f1f5f9'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <rect x="2" y="5" width="20" height="14" rx="2"/>
                    <line x1="2" y1="10" x2="22" y2="10"/>
                  </svg>
                </div>
                <div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                    Bank Account Verification
                  </h2>
                  <p style={{ fontSize: '14px', color: '#6b7280', margin: '4px 0 0 0' }}>
                    Enter bank details to verify
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowBankVerifyModal(false);
                  setBankAccountNumber('');
                  setBankIfscCode('');
                }}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>

            {/* Content */}
            <div style={{ padding: '24px' }}>
              {/* Account Number Input */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#374151', 
                  marginBottom: '12px' 
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="5" width="20" height="14" rx="2"/>
                    <line x1="2" y1="10" x2="22" y2="10"/>
                  </svg>
                  <span>Bank Account Number</span>
                </label>
                <input
                  type="text"
                  value={bankAccountNumber}
                  onChange={(e) => setBankAccountNumber(e.target.value.replace(/\D/g, ''))}
                  placeholder="Enter account number"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    fontSize: '16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '12px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* IFSC Code Input */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#374151', 
                  marginBottom: '12px' 
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                  </svg>
                  <span>IFSC Code</span>
                </label>
                <input
                  type="text"
                  value={bankIfscCode}
                  onChange={(e) => setBankIfscCode(e.target.value.toUpperCase())}
                  placeholder="Enter IFSC code"
                  maxLength="11"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    fontSize: '16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '12px',
                    outline: 'none',
                    boxSizing: 'border-box',
                    textTransform: 'uppercase'
                  }}
                />
              </div>

              {/* Actions */}
              {/* Verified Beneficiary Name Display */}
              {verifiedBeneficiaryName && (
                <div style={{
                  marginBottom: '24px',
                  padding: '16px',
                  backgroundColor: bankVerificationStatus === 'success' ? '#dcfce7' : '#fee2e2',
                  borderRadius: '12px',
                  border: `1px solid ${bankVerificationStatus === 'success' ? '#86efac' : '#fecaca'}`
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      backgroundColor: bankVerificationStatus === 'success' ? '#bbf7d0' : '#fecaca',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      {bankVerificationStatus === 'success' ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                          <polyline points="22,4 12,14.01 9,11.01"/>
                        </svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="15" y1="9" x2="9" y2="15"/>
                          <line x1="9" y1="9" x2="15" y2="15"/>
                        </svg>
                      )}
                    </div>
                    <div>
                      <p style={{ 
                        color: bankVerificationStatus === 'success' ? '#15803d' : '#991b1b',
                        fontWeight: '600', 
                        marginBottom: '4px', 
                        fontSize: '14px' 
                      }}>
                        Beneficiary Name
                      </p>
                      <p style={{ 
                        color: bankVerificationStatus === 'success' ? '#166534' : '#7f1d1d',
                        fontSize: '16px', 
                        fontWeight: 'bold',
                        margin: 0 
                      }}>
                        {verifiedBeneficiaryName}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={handleBankVerify}
                  disabled={!bankAccountNumber || !bankIfscCode || bankIfscCode.length !== 11}
                  style={{
                    flex: 1,
                    backgroundColor: '#D32028',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    opacity: (!bankAccountNumber || !bankIfscCode || bankIfscCode.length !== 11) ? 0.5 : 1
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22,4 12,14.01 9,11.01"/>
                  </svg>
                  <span>{loading?"Verifying":"Verify Bank Account"}</span>
                </button>
                <button
                 onClick={() => {
                  setShowBankVerifyModal(false);
                  setBankAccountNumber('');
                  setBankIfscCode('');
                  setVerifiedBeneficiaryName('');
                  setBankVerificationStatus(null);
                }}
                  style={{
                    padding: '12px 24px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: 'white',
                    color: '#374151',
                    borderRadius: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CkycConfirmationModal
        isOpen={showCkycConfirmationModal}
        errorMessage={ckycConfirmError}
        onConfirm={handleCkycConfirmation}
        onCancel={handleCkycConfirmationCancel}
        mobileNumber={profileDetails?.mobile}
        refNumber={currentCkycRefNumber}
      />

      <FaceMatchConfirmationModal
        isOpen={showFaceMatchConfirmationModal}
        onConfirm={handleFaceMatchConfirmation}
        onCancel={handleFaceMatchConfirmationCancel}
      />

      <InitiateCkycConfirmationModal
        isOpen={showInitiateCkycConfirmModal}
        onConfirm={handleInitiateCkycConfirm}
        onCancel={handleInitiateCkycCancel}
      />

      {/* Modern CKYC Modal */}
      <ModernCKYCModal
        isOpen={showCkycModal}
        onClose={closeCkycModal}
        modalMessage={ckycModalMessage}
        requiresOtpInput={ckycRequiresOtpInput}
        otpInput={otpInput}
        setOtpInput={setOtpInput}
        onOtpSubmit={handleCkycOtpSubmit}
        isLoading={isCkycLoading}
        apiError={ckycApiError}
        onRetry={handleRetry}
        onResendOtp={handleResendCkycOtp} // Pass the new handler
        resendOtpTimer={resendOtpTimer}     // Pass the timer state
      />
    </div>
  );
}
